import { useSettings } from '@wix/tpa-settings/react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';

import { DataHook } from '../../../../../../types';
import settingsParams from '../../../../settingsParams';
import CameraSmall from './CameraSmall';
import DividerSmall from './DividerSmall';
import EmojiSmall from './EmojiSmall';
import { classes } from './EmptyEditor.st.css';
import GifSmall from './GifSmall';
import VideoSmall from './VideoSmall';

type EmptyEditorProps = {
  setEditMode?: (value: boolean) => void;
};

export const EmptyEditor: FC<EmptyEditorProps> = ({ setEditMode }) => {
  const settings = useSettings();
  const { t } = useTranslation();

  const handleClick = () => {
    setEditMode?.(true);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  const placeholder =
    settings.get(settingsParams.aboutDescriptionPlaceholder) ||
    t('settings.texts-tab.placeholder-default-text');

  return (
    <div
      /* remove rootOld when merging specs.membersAbout.accessibleRce */
      className={setEditMode ? classes.root : classes.rootOld}
      {...(setEditMode
        ? { onClick: handleClick, onKeyDown: handleKeyDown }
        : {})}
      tabIndex={0}
      data-hook={DataHook.EmptyEditor}
    >
      <Text tagName="div" className={classes.placeholder}>
        {placeholder}
      </Text>
      <div className={classes.footer}>
        <CameraSmall className={classes.icon} />
        <DividerSmall className={classes.icon} />
        <VideoSmall className={classes.icon} />
        <GifSmall className={classes.icon} />
        <EmojiSmall className={classes.icon} />
      </div>
    </div>
  );
};
